var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTune(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 14V9H8V10.75H14V12.25H8V14H6.5ZM0 12.25V10.75H5V12.25H0ZM3 9.5V7.75H0V6.25H3V4.5H4.5V9.5H3ZM6 7.75V6.25H14V7.75H6ZM9 5V0H10.5V1.75H14V3.25H10.5V5H9ZM0 3.25V1.75H8V3.25H0Z",
    fill: "#9AA0A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTune);
export default __webpack_public_path__ + "static/media/Tune.a3ee04d22644c29721c911d4aea18ab0.svg";
export { ForwardRef as ReactComponent };